module.exports = __webpack_public_path__ + "img/aidmodel_md.6fccc241.png";